import {
    TRANSACTIONS_CARD_BEGIN,
    TRANSACTIONS_CARD_SUCCESS,
    TRANSACTIONS_CARD_FAILURE
  } from 'actions/transactions';

  const initialState = {
    items: [],
    loading: false,
    error: false,
  };

  export default function transactions(state = initialState, action) {
    switch (action.type) {
      case TRANSACTIONS_CARD_BEGIN:
        return { ...state, loading: true };
      case TRANSACTIONS_CARD_SUCCESS:
        return {
          ...state,
          items: action.payload.transactions,
          loading: false,
          error: false,
        };
      case TRANSACTIONS_CARD_FAILURE:
        return { ...state, error: action.error, loading: false };
      default:
        return state;
    }
  }
